"use client";

import { excludedRoutes } from "@/components/section/pageProtectedAccess/PageProtectedAccess";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import React, { PropsWithChildren } from "react";

const hideFooterPaths = [
  ...excludedRoutes,
  "/waitlist",
  "/profile",
  "/auth/signin",
  "/auth/error",
  "/hotel/search/researcher",
  "/onboarding",
  "/challenge",
];

const FooterWrapper: React.FC<
  PropsWithChildren<{
    bypassHiddenCondition?: boolean;
  }>
> = ({ children, bypassHiddenCondition }) => {
  const pathname = usePathname();

  // Check if current path matches hotel search patterns with UUID (e.g., /hotel/search/c7a132fc-8bf1-4c0f-96d6-4c5fa28341c7)
  // UUID pattern: 8-4-4-4-12 hexadecimal characters
  const uuidPattern =
    /^\/hotel\/search\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const isHotelSearchWithUuid = uuidPattern.test(pathname);

  // Hide footer for excluded paths (with prefix match for nested routes) or hotel search with UUID
  const matchesHidePath = hideFooterPaths.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
  const shouldHide =
    (matchesHidePath || isHotelSearchWithUuid) && !bypassHiddenCondition;

  return (
    <footer
      className={cn("flex w-full flex-col pb-24 pt-14", shouldHide && "hidden")}
    >
      {children}
    </footer>
  );
};

export default FooterWrapper;
